module.exports = __webpack_public_path__ + "assets/img/teacher.16d6a2ff.png";